import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../services.service';
import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-jobphotosproducts',
  templateUrl: './jobphotosproducts.component.html',
  styleUrls: ['./jobphotosproducts.component.css']
})
export class JobphotosproductsComponent implements OnInit {
  counter = [];
  counter2 = [];
  cartCnt;
  apiBaseUrl: string = environment.apiBaseUrl;
  job_id;
  image_id;
  i = 0;
  required = 0;
  is_individual;
  userData;
  product_id;
  image;
  onlineFee;
  taxTotal: any;
  subTotal: any;
  finalAmount: any;
  finalAmountTotal: any;
  reqprod: boolean = true;
  productsdata;
  addtocartdisabled = false;
  filename;
  param = {};
  val;
  shipmentCharge: any;
  header = 'l-header';
  navbar = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
  userId: any;
  constructor(private activateroute: ActivatedRoute, private _service: ServicesService, private router: Router) {
    this.activateroute.queryParams.subscribe(params => {
      this.job_id = params['job_id'];
      this.image_id = params['image_id'];
      this.is_individual = params['is_individual'];
      this.filename = params['file_name'] ? params['file_name'] : '';
    });
  }

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData == undefined || this.userData == null){
      this.userId = '';
    }else{
      this.userId = this.userData['id'];
    }
    const userToken = localStorage.getItem('userToken');

    if (userToken && this.userData) {
      this.param['id'] = this.userData['id'];
      this.param['token'] = userToken;
    }
    this.productsdata = [
      {
        additionalimage: '',
        required_products: ''
      }
    ];
    // alert('here');
    this.getImage(this.image_id, this.filename);

    this.getJobproduct(this.job_id, this.is_individual);
    this.getShipmentCharge(this.job_id);
  }

  ConvertToFloat(val) {
    return parseFloat(val);
  }
  ConverTotal(val) {
    console.log(val);
    this.shipmentCharge = this.shipmentCharge;
    this.subTotal = val;
    this.taxTotal = ((this.subTotal ) * 15) / 100;
    this.finalAmount =  parseFloat(this.subTotal) + parseFloat(this.taxTotal);
    this.onlineFee = 1.5 + (this.finalAmount * 3.5) / 100;
    this.finalAmountTotal = parseFloat(this.onlineFee) + parseFloat(this.finalAmount);
    console.log( this.finalAmountTotal);
    return   this.finalAmountTotal;
  }



//   getSubTotalAmoutShow(price){
//     // console.log('estdgedsc',price,quantity);

    
// //    if(price>0){
//     this.subTotalshow = price*1;
//     this.taxTotal = ((this.subTotalshow) * 15) / 100;
//     this.finalAmountshow =   this.subTotalshow + this.taxTotal;
//     this.onlineFee = 1.5 + (this.finalAmountshow *3.5)/100;
//     this.finalAmountshow =  1*(this.onlineFee + this.finalAmountshow);
   
    
//     // console.log(this.finalAmountshow);
//     return  this.finalAmountshow;
// //    }
    

// }


  increment(index) {
    // console.log(index);
    this.counter[index]++;
  }

  decrement(index) {
    // console.log(index);
    if (this.counter[index] > 1) {
      this.counter[index]--;
    }
    // console.log("counter", this.counter[index]);
  }

  decrementReq(index) {
    if (this.counter2[index] > 1)
      // console.log(index);
      this.counter2[index]--;
    // this.counter2("Counter2", this.counter2[index]);
  }

  incrementReq(index) {
    console.log(index);
    this.counter2[index]++;
    // this.counter2("Counter2", this.counter2[index]);
  }

  getImage(imageid, filename) {
    // alert('here');
    const data = { file_name: filename, imageid: imageid };
    // console.log("data==",data);
    this._service.getImage(data).subscribe(
      (res: any) => {
        this.image = res.result[0].photo;
        this.filename = res.result[0].file_name;
        // console.log("res.result",res.result);
      },
      (err: HttpErrorResponse) => {}
    );
  }

  getJobproduct(jobid, isindividual) {
    // alert('here');
    const obj = { job_id: this.job_id, is_individual: this.is_individual };
    this._service.getJobproduct(obj).subscribe(
      (data: any) => {
        if (data.result['additionalimages'].length == 0) {
          if (data.result['required_products'].length == 0) {
            swal({
              title: 'Oops! Products not found',
              text: 'No Products Found For selected images',
              type: 'warning',
              confirmButtonText: 'Ok'
            });
          }
        }
        /*for(let item of data.result['additionalimages']; this.i++ ) {
        this.counter[this.i]= '1';
        // this.i++;
      }*/
        data.result['additionalimages'].forEach((item, index) => {
          // console.log("item=",item); // 9, 2, 5
          // console.log(index); // 0, 1, 2
          this.counter[index] = 1;
          index++;
        });
        data.result['required_products'].forEach((item, index) => {
          // console.log("item=",item); // 9, 2, 5
          // console.log(index); // 0, 1, 2
          this.counter2[index] = 1;
          this.required = 1;
          index++;
        });

        this.productsdata = data.result;

        // for(let item of this.productsdata['additionalimages'] ){
        //   // this.counter[i] = 1;
        //   // i++;
        //   alert(productsdata);
        // }
        console.log(this.productsdata);
        // this.productsdata.map({

        // });
      },
      (err: HttpErrorResponse) => {}
    );
  }

  checkAdditionalProductAddToCart(job_id, product_id, id = 0, flag = 0) {
    const userData = JSON.parse(localStorage.getItem('userData'));
    // userData.hasOwnProperty('id')
    const user_id = userData ? userData.id : '';
    const obj = { job_id: job_id, product_id: product_id, user_id: user_id, is_individual: this.is_individual };
    //  console.log(obj);
    this._service.checkAdditionalProductAddToCart(obj).subscribe((data: any) => {
      if (data.result === 1) {
        this.addToCart(product_id, id, flag);
      } else {
        if (user_id == '') {
          return;
        }
        swal({
          title: 'Oops!',
          text: data.msg,
          type: 'warning',
          confirmButtonText: 'Ok'
        });
      }
    });
  }
  getShipmentCharge(jobId) {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('userToken');
    const data = { token: token };

    this._service.getShipmentCharge(data).subscribe((data: any) => {
      if (data.status == 200 && data.result == true) {
        this.shipmentCharge = 100;
      } else {
        this.shipmentCharge = 0;
      }
    });
  }

  addToCart(prodid, position, reqprod) {
    // console.log("index",position);
    // const length = this.individual_photos_quantity;
    // console.log('addToCart', this.individual_photos_quantity[0]);
    let allPhotoesSelectedFlag = true;
    // console.log(this.group_photos_quant.length);
    // console.log(this.individual_photos_quant.length);
    // if(this.group_photos_quant.length!=this.maxGrplength){
    //   allPhotoesSelectedFlag = false;
    // }
    // if(this.individual_photos_quant.length!=this.maxIndlength){
    //   allPhotoesSelectedFlag = false;
    // }

    if (!allPhotoesSelectedFlag) {
      swal({
        title: 'Oops!',
        text: 'Please select all required photos for this product',
        type: 'warning',
        confirmButtonText: 'Ok'
      });
    } else {
      this.addtocartdisabled = true;
      const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {};

      const user_id = userData.hasOwnProperty('id') ? userData.id : '';
      if (user_id == '') {
        /* swal({
          title: 'Oops!',
          text: 'In order to add products to your cart and complete an order, you have to be logged in to a verified account. Please login or Register your account to continue.',
          type: 'warning',
          confirmButtonText: 'Ok'
        }); */
        return;
      }

      // let item_id;
      // let item_id_arr   = [];
      // console.log("individphotosquant",this.group_photos_quant);
      // item_id_arr   = this.individual_photos_quant.concat(this.group_photos_quant);
      //   console.log('Item ID Arr',item_id_arr);
      // let item_det_arr   = {};req_prod:boolean = false;
      // let item_det_pocket   = [];
      var data = {};

      if (reqprod == '1') {
        if (this.counter2[position] < 1) {
          swal({
            title: 'Opps!',
            text: 'Please select atleast 1 quantity',
            type: 'error',
            confirmButtonText: 'Ok'
          });
          return;
        }
        data = { user_id: user_id, product_id: prodid, job_id: this.job_id, item_id: [this.image_id], quantity: this.counter2[position] };
      }
      if (reqprod == '2') {
        if (this.counter[position] < 1) {
          swal({
            title: 'Opps!',
            text: 'Please select atleast 1 quantity',
            type: 'error',
            confirmButtonText: 'Ok'
          });
          return;
        }
        data = { user_id: user_id, product_id: prodid, job_id: this.job_id, item_id: [this.image_id], quantity: this.counter[position] };
      }

      // console.log('add to cart data', data);

      this._service.addproduct(data).subscribe((data1: any) => {
        // console.log('add to cart response', data1);
        const that = this;
        if (data1) {
          swal({
            title: 'Congratulations!',
            text: 'The product has been added to your cart.',
            type: 'success',
            confirmButtonText: 'Ok'
          }).then(function(isConfirm) {
            //that.router.navigate(['/product'],{ queryParams: { jobid: that.jobid } } );
            // that.router.navigate(['/product', that.jobid]);
          });
        } else {
          swal({
            title: 'Opps!',
            text: 'Something went wrong',
            type: 'error',
            confirmButtonText: 'Ok'
          });
        }
        this.cartCount();
      });
    }
  }
  checkAdditionalProduct(required) {
    const userData = JSON.parse(localStorage.getItem('userData'));
    // userData.hasOwnProperty('id')
    const user_id = userData ? userData.id : '';
    const obj = { job_id: this.job_id, user_id: user_id };
    if (user_id == '') {
      /* swal({
        title: 'Oops!',
        text: 'In order to add products to your cart and complete an order, you have to be logged in to a verified account. Please login or Register your account to continue.',
        type: 'warning',
        confirmButtonText: 'Ok'
      }); */
      return;
    }
    if (required == 0) {
      this.router.navigate(['/cart']);
      return;
    }
    this._service.checkAdditionalProd(obj).subscribe((data1: any) => {
      if (data1) {
        if (data1.result == 1) {
          swal({
            text: 'Are you sure you want to continue to your cart without adding some of the additional products to your cart?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then(results => {
            if (results.value) {
              this.router.navigate(['/cart']);
            }
          });
        } else if (data1.result == 0) {
          this.router.navigate(['/cart']);
        }
      } else {
        swal({
          title: 'Opps!',
          text: 'Something went wrong',
          type: 'error',
          confirmButtonText: 'Ok'
        });
      }
    });
  }
  showImage(src) {
    const imgUrl = src;
    // console.log(imgUrl);
    swal({
      html: "<img src='" + imgUrl + "' style='width:100%;'>",
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Close',
      cancelButtonColor: '#d33',
      //width:'600px',
      //height:'600px',
      customClass: 'swal-wide'
    });
  }
  cartCount() {
    this._service.cartCount(this.param).subscribe((cartData: any) => {
      if (cartData.status === 200) {
        this.cartCnt = cartData.result;
      } else {
        this.router.navigate(['login']);
      }

      // console.log(this.cartCnt);
    });
  }
  // console.log(this.counter);
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/jobphotosproducts/jobphotosproducts.component.ts